<script>
import {
    modalState, hideModal, showModal
} from "@app/store/modalStore.svelte.js";
import {
    projectState
} from "@app/store/projectStore.svelte.js";
import {
    eventGroupState
} from "@app/store/eventGroupStore.svelte.js";
import {
    historyState, insertHistoryAction, resetHistory
} from "@app/store/historyStore.svelte.js";
import { toast } from '@zerodevx/svelte-toast';
import stripTags from "@cclib/functions/quill/stripTags.js";
import {
    fade
} from "svelte/transition";
import * as m from '@app/paraglide/messages.js';

let removeSdhDefaults = JSON.parse(localStorage.getItem("cc-remove-sdh-defaults")) || {};
let removeSquareBrackets = $state(removeSdhDefaults.removeSquareBrackets),
    removeCurlyBraces = $state(removeSdhDefaults.removeCurlyBraces),
    removeBrackets = $state(removeSdhDefaults.removeBrackets),
    removeMusicNotes = $state(removeSdhDefaults.removeMusicNotes),
    removeStars = $state(removeSdhDefaults.removeStars),
    removeUpperCaseSpeakerLabel = $state(removeSdhDefaults.removeUpperCaseSpeakerLabel),
    removeUpperCaseLine = $state(removeSdhDefaults.removeUpperCaseLine),
    removeColorFormatting = $state(removeSdhDefaults.removeColorFormatting),
    applyTo = $state("all");

let selectedCount = $derived(eventGroupState[projectState.selected]?.selected.length ?? 0);
let noOptionsChecked = $derived(
    !removeSquareBrackets &&
    !removeCurlyBraces &&
    !removeBrackets &&
    !removeMusicNotes &&
    !removeStars &&
    !removeUpperCaseSpeakerLabel &&
    !removeUpperCaseLine &&
    !removeColorFormatting
);

function unwrapElement(element) {
    element.replaceWith(...element.childNodes);
}

const removeFunc = {
    squareBrackets: function(removeText, event) {
        if (!removeText) {
            return event.text;
        }
        
        return event.text.replace(/<p.+\[.+\]<\/p>/g, "");
    },
    curlyBraces: function(removeText, event) {
        if (!removeText) {
            return event.text;
        }

        return event.text.replace(/<p.+\{.+\}<\/p>/g, "");

    },
    brackets: function(removeText, event) {
        if (!removeText) {
            return event.text;
        }

        return event.text.replace(/<p.+\(.+\)<\/p>/g, "");
    },
    musicNotes: function(removeText, event) {
        if (!removeText) {
            return event.text;
        }
        return event.text.replace(/<p.+\♪+.+\♪+<\/p>/g, "");
    },

    stars: function(removeText, event) {
        if (!removeText) {
            return event.text;
        }

        return event.text.replace(/<p.+\*+.+\*+<\/p>/g, "");

    },
    upperCaseSpeakerLabel: function(removeText, event) {
        if (!removeText) {
            return event.text;
        }

        return event.text.replace(/<p.+[A-Z\s]+:\s+<\/p>/g, "");

    },
    upperCaseLine: function(removeText, event) {
        if (!removeText) {
            return event.text;
        }

        return event.text.replace(/<p.+[A-Z\s]+\s+<\/p>/g, "");
    },
    colorFormatting: function(removeFormatting, event) {
        if (!removeFormatting || !event.text) {
            return event.text;
        }

        const template = document.createElement("template");
        template.innerHTML = event.text;
        const colorFormattedSpans = [];

        template.content.querySelectorAll("[style]").forEach(element => {
            const hadColorFormatting = element.style.getPropertyValue("color") || element.style.getPropertyValue("background-color");

            element.style.removeProperty("color");
            element.style.removeProperty("background-color");

            if (!element.getAttribute("style")?.trim()) {
                element.removeAttribute("style");
            }

            if (hadColorFormatting && element.tagName.toLowerCase() === "span") {
                colorFormattedSpans.push(element);
            }
        });

        colorFormattedSpans.forEach(element => {
            if (element.parentNode && element.attributes.length === 0) {
                unwrapElement(element);
            }
        });

        return template.innerHTML;
    }
}

async function removeSdh() {
    const applyToAllEvents = applyTo !== "selected" || selectedCount === 0;

    if (applyToAllEvents) {
        eventGroupState[projectState.selected].events.forEach((event, index, events) => {
            events[index].text = removeFunc.squareBrackets(removeSquareBrackets, event);
            events[index].text = removeFunc.curlyBraces(removeCurlyBraces, event);
            events[index].text = removeFunc.brackets(removeBrackets, event);
            events[index].text = removeFunc.musicNotes(removeMusicNotes, event);
            events[index].text = removeFunc.stars(removeStars, event);
            events[index].text = removeFunc.upperCaseSpeakerLabel(removeUpperCaseSpeakerLabel, event);
            events[index].text = removeFunc.upperCaseLine(removeUpperCaseLine, event);
            events[index].text = removeFunc.colorFormatting(removeColorFormatting, event);
        });
    } else {
        eventGroupState[projectState.selected].selected.forEach(eventIndex => {
            eventGroupState[projectState.selected].events[eventIndex].text = removeFunc.squareBrackets(removeSquareBrackets, eventGroupState[projectState.selected].events[eventIndex]);
            eventGroupState[projectState.selected].events[eventIndex].text = removeFunc.curlyBraces(removeCurlyBraces, eventGroupState[projectState.selected].events[eventIndex]);
            eventGroupState[projectState.selected].events[eventIndex].text = removeFunc.brackets(removeBrackets, eventGroupState[projectState.selected].events[eventIndex]);
            eventGroupState[projectState.selected].events[eventIndex].text = removeFunc.musicNotes(removeMusicNotes, eventGroupState[projectState.selected].events[eventIndex]);
            eventGroupState[projectState.selected].events[eventIndex].text = removeFunc.stars(removeStars, eventGroupState[projectState.selected].events[eventIndex]);
            eventGroupState[projectState.selected].events[eventIndex].text = removeFunc.upperCaseSpeakerLabel(removeUpperCaseSpeakerLabel, eventGroupState[projectState.selected].events[eventIndex]);
            eventGroupState[projectState.selected].events[eventIndex].text = removeFunc.upperCaseLine(removeUpperCaseLine, eventGroupState[projectState.selected].events[eventIndex]);
            eventGroupState[projectState.selected].events[eventIndex].text = removeFunc.colorFormatting(removeColorFormatting, eventGroupState[projectState.selected].events[eventIndex]);
        });
    }
    
    eventGroupState[projectState.selected].events = eventGroupState[projectState.selected].events.filter(event => {
        return stripTags(event.text) !== "";
    });

    eventGroupState[projectState.selected].selected = [];
    
    insertHistoryAction({
        name: "remove SDH", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });

    toast.push(m.sdh_removal_complete(), {classes: ['toast-success']});

    localStorage.setItem("cc-remove-sdh-defaults", JSON.stringify({
        removeSquareBrackets: removeSquareBrackets,
        removeCurlyBraces: removeCurlyBraces,
        removeBrackets: removeBrackets,
        removeMusicNotes: removeMusicNotes,
        removeStars: removeStars,
        removeUpperCaseSpeakerLabel: removeUpperCaseSpeakerLabel,
        removeUpperCaseLine: removeUpperCaseLine,
        removeColorFormatting: removeColorFormatting
    }));

    hideModal();
}
</script>

<div
    transition:fade={{ duration: 100 }}
    class="modal {modalState.selected === 'removeSdh' ? 'show d-block' : ''}"
    role="dialog"
    aria-labelledby="removeSdhModalTitle"
    aria-describedby="removeSdhModalDesc"
    tabindex="-1"
    id="RemoveSdhModal"
>
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="removeSdhModalTitle">{m.remove_sdh_elements()}</h4>
                <button
                    type="button"
                    class="btn-close"
                    id="removeSdhCloseBtn"
                    aria-label={m.close_modal()}
                    onclick={hideModal}
                ></button>
            </div>
            <div class="modal-body">
                <p id="removeSdhModalDesc" class="sr-only">{m.remove_sdh_description()}</p>
                <form>
                    <h6 class="text-secondary text-uppercase small fw-bold">{m.sdh_text_removal_heading()}</h6>
                    <div class="row">
                        <div class="col-6">
                            <div class="mb-3 form-check">
                                <input type="checkbox" class="form-check-input" id="removeSquareBrackets" bind:checked={removeSquareBrackets} aria-describedby="squareBracketsDesc">
                                <label class="form-check-label" for="removeSquareBrackets">{m.remove_text_square_brackets()}</label>
                                <span id="squareBracketsDesc" class="sr-only">{m.remove_square_brackets_desc()}</span>
                            </div>
                            <div class="mb-3 form-check">
                                <input type="checkbox" class="form-check-input" id="removeCurlyBraces" bind:checked={removeCurlyBraces}>
                                <label class="form-check-label" for="removeCurlyBraces">{m.remove_text_curly_braces()}</label>
                            </div>
                            <div class="mb-3 form-check">
                                <input type="checkbox" class="form-check-input" id="removeBrackets" bind:checked={removeBrackets}>
                                <label class="form-check-label" for="removeBrackets">{m.remove_text_parentheses()}</label>
                            </div>
                            <div class="mb-3 form-check">
                                <input type="checkbox" class="form-check-input" id="removeMusicNotes" bind:checked={removeMusicNotes}>
                                <label class="form-check-label" for="removeMusicNotes">{m.remove_text_music_notes()}</label>
                            </div>
                            <div class="mb-3 form-check">
                                <input type="checkbox" class="form-check-input" id="removeStars" bind:checked={removeStars}>
                                <label class="form-check-label" for="removeStars">{m.remove_text_stars()}</label>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="mb-3 form-check">
                                <input type="checkbox" class="form-check-input" id="removeUpperCaseSpeakerLabel" bind:checked={removeUpperCaseSpeakerLabel} aria-describedby="upperCaseSpeakerDesc">
                                <label class="form-check-label" for="removeUpperCaseSpeakerLabel">{m.remove_uppercase_before_colon()}</label>
                                <span id="upperCaseSpeakerDesc" class="sr-only">{m.remove_uppercase_speaker_labels()}</span>
                            </div>
                            <div class="mb-3 form-check">
                                <input type="checkbox" class="form-check-input" id="removeUpperCaseLine" bind:checked={removeUpperCaseLine}>
                                <label class="form-check-label" for="removeUpperCaseLine">{m.remove_line_all_uppercase()}</label>
                            </div>
                        </div>
                    </div>

                    <hr class="my-3">

                    <h6 class="text-secondary text-uppercase small fw-bold">{m.sdh_formatting_heading()}</h6>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="removeColorFormatting" bind:checked={removeColorFormatting} aria-describedby="colorFormattingDesc">
                        <label class="form-check-label" for="removeColorFormatting">{m.remove_color_formatting()}</label>
                        <span id="colorFormattingDesc" class="sr-only">{m.remove_color_formatting_desc()}</span>
                    </div>
                </form>
            </div>
            <div class="modal-footer d-flex justify-content-between align-items-center flex-wrap">
                <fieldset class="d-flex align-items-center flex-wrap">
                    <legend class="visually-hidden">{m.apply_to()}</legend>
                    <span class="text-secondary me-3" aria-hidden="true">{m.apply_to()}:</span>
                    <div class="form-check form-check-inline mb-0">
                        <input class="form-check-input" type="radio" name="removeSdhScopeRadios" id="removeSdhScopeAll" value="all" bind:group={applyTo}>
                        <label class="form-check-label" for="removeSdhScopeAll">{m.all_events()}</label>
                    </div>
                    <div class="form-check form-check-inline mb-0 me-0">
                        <input class="form-check-input" type="radio" name="removeSdhScopeRadios" id="removeSdhScopeSelected" value="selected" bind:group={applyTo} disabled={selectedCount === 0}>
                        <label class="form-check-label" for="removeSdhScopeSelected">{m.selected_events_only()} ({selectedCount})</label>
                    </div>
                </fieldset>
                <button
                    class="btn btn-primary"
                    type="button"
                    id="removeSdhApplyBtn"
                    aria-label={m.apply_sdh_removal()}
                    disabled={noOptionsChecked}
                    onclick={removeSdh}
                >{m.remove_sdh()}</button>
            </div>
        </div>
    </div>
</div>
